<div class="gantt-container" >
  <div class="gantt-header">
    <div class="machine-label">Blenders</div>
    @for(hour of hours; track hour) {
      <div class="hour-label">
        {{ hour }}:00
      </div>
    }
  </div>
  <div class="hour-separators">
    <div></div>
    @for(hour of hours; track hour) {
      <div
      class="hour-separator" 
      [ngStyle]="{'grid-column': (hour - startHour) * 60 + ' / span ' + 60}">
    </div>
    }   
  </div>


  @for(blender of blenders; track blender; let first = $first; let i = $index) {
    <div class="gantt-grid" [ngStyle]="{'background-color': (i % 2 === 0 ? 'white' : '#f6f6f6')}">
      <div class="machine-label">{{ blender.id }}</div>
      @for(task of blenderTasks; track task) {
        @if(task.blender.id == blender.id || task.blender == blender.id) {
          @if (task.type === 'order') {
            @if (task.nuevo_production_time > 0 && task.hora_inicio_blender >= startHour && task.hora_inicio_blender < endHour) {
              <div class="task"
                  [ngClass]="getGanttNgClass(task, 'is-planned-task')"
                  [ngStyle]="{'grid-column': trunc(((task.hora_inicio_blender) - startHour) * 60 + 2 ) + ' / span ' + gridSpan(task.nuevo_production_time * 60)}" (click)="openModal(task)">
                {{ task.name || task.product?.description }}
              </div>
            }
            
          }
          @if (task.type === 'calidad') {
            @if (task.nuevo_quality_time > 0  && task.hora_inicio_calidad >= startHour && task.hora_inicio_calidad < endHour) {
              <div class="quality"
                  [ngClass]="getGanttNgClass(task, 'is-planned-quality')"
                  [ngStyle]="{'grid-column': trunc(((task.hora_inicio_calidad) - startHour) * 60 + 2) + ' / span ' + gridSpan(task.nuevo_quality_time * 60)}">
              </div>
            }
            
          }
          @else if (task.type === 'limpieza') {
            @if (task.duration > 0  && task.hora_inicio >= startHour) {
              <div class="cleaning"  [ngClass]="{'is-planned-cleaning': task.is_planned}" 
                  [ngStyle]="{'grid-column': trunc((task.hora_inicio - startHour) * 60  + 2) + ' / span ' + gridSpan(task.duration)}" (click)="openModal(task)">
                {{ task.name }}
              </div>

            }
          }
        }

      }
    </div>
  }
  @if (showCameraHeatmapRow || cameraHeatmapSegments.length > 0) {
    <div class="gantt-header camera-heatmap-header">
      <div class="machine-label" id="camera-heatmap-heading">Cámaras</div>
      @for(hour of hours; track hour) {
        <div class="hour-label">
          {{ hour }}:00
        </div>
      }
    </div>
    <div class="gantt-grid camera-heatmap-row">
      <div class="machine-label">% ocupación</div>
      @for (segment of cameraHeatmapSegments; track $index) {
        <div
          class="camera-heatmap-slot"
          role="img"
          [attr.aria-label]="segment.ariaLabel"
          [pTooltip]="segment.hoverLabel"
          [tooltipOptions]="cameraHeatmapTooltipOptions"
          tooltipPosition="top"
          appendTo="body"
          [showDelay]="100"
          [hideDelay]="0"
          [ngStyle]="{
            'grid-column': segment.gridColumnStart + ' / span ' + segment.span,
            'background-color': segment.color
          }">
        </div>
      }
    </div>
  }
  <div class="gantt-divider">
    <div class="next-icon">
      <fa-icon [icon]="faCircleChevronLeft" (click)="onDateIncrement(-1)"></fa-icon>
    </div>
    <div class="next-icon">
      <fa-icon [icon]="faCircleChevronRight" (click)="onDateIncrement(1)"></fa-icon>
    </div>
  </div>
  <div class="gantt-header">
    <div class="machine-label">Envasadoras</div>
    @for(hour of hours; track hour) {
      <div class="hour-label">
        {{ hour }}:00
      </div>
    }
  </div>

  @for(packagingMachine of packagingMachines; track packagingMachine; let first = $first; let i = $index) {
    <div class="gantt-grid" [ngStyle]="{'background-color': (i % 2 === 0 ? 'white' : '#f6f6f6')}">
      <div class="machine-label">{{ packagingMachine.id }}</div>
      @for(task of packagingTasks; track task) {
        @if (task.nuevo_packaging_time > 0  && task.hora_inicio_envasadora >= startHour && task.hora_inicio_envasadora < endHour) {
          @if(task.packaging_machine.id === packagingMachine.id) {
            @if (task.packaging_time) {
              <div class="packaging"
                  [ngClass]="getGanttNgClass(task, 'is-planned-packaging')"
                  [ngStyle]="{'grid-column': trunc(((task.hora_inicio_envasadora) - startHour) * 60 + 2)+ ' / span ' + gridSpan(task.nuevo_packaging_time * 60)}" (click)="openModal(task)">
                {{ task.name }}
              </div>
            }
          }
        }
      }
    </div>
  }
</div>
<div class="modal" [ngClass]="{'is-active': isModalActive }">
  <div class="modal-background"></div>
  @if(selectedOrder) {
    <div class="modal-card">
      <header class="modal-card-head">

        <p class="modal-card-title">
          @if (selectedOrder.type === 'limpieza') {
            Limpieza
          } @else {
            Orden {{ selectedOrder.lote_interno ?? selectedOrder.id }}
          }
        </p>
        <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
      </header>
      <section class="modal-card-body">
        @if (selectedOrder.type === 'order') {
          <div class="columns is-multiline">
            <div class="column is-6">
              <h1 class="title is-4 mb-5">Información</h1>            
              <div class="field">
                <span class="value-title">Producto: </span>
                <span class="value">{{selectedOrder.product.id}} - {{selectedOrder.product.description}}</span>
              </div>
              <div class="field">
                <span class="value-title">Naturaleza del producto:</span>
                <span  class="value">{{selectedOrder.product_nature}}</span>
              </div>
              <div class="field">
                <span class="value-title">Blender:</span>
                <span>{{selectedOrder.blender.id}}</span>
              </div>
              <div class="field">
                <span class="value-title">Peso:</span>
                <span class="value">{{selectedOrder.weight}} kg</span>
              </div>
              <div class="field">
                <span class="value-title">Tipo demanda: </span>
                <span  class="value">{{selectedOrder.demand_type}}</span>
              </div>
              <div class="field">
                <span class="value-title">Last day:</span>
                <span  class="value">{{selectedOrder.last_day | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>  
              <div class="field">
                <span class="value-title">Tiempo de preparación:</span>
                <span class="value">{{selectedOrder.preparation_time != null ? selectedOrder.preparation_time + 'h' : '—'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha inicio preparación teórica:</span>
                <span class="value">{{selectedOrder.fecha_inicio_preparacion_teorica | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha inicio preparación real:</span>
                <span class="value">{{(selectedOrder.fecha_inicio_preparacion_real || selectedOrder.fecha_inicio_preparacion) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha fin preparación:</span>
                <span class="value">{{selectedOrder.fecha_fin_preparacion | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Tiempo de producción:</span>
                <span class="value">{{selectedOrder.production_time}}h</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha inicio blender:</span>
                <span class="value">{{(selectedOrder.original_fecha_inicio_blender || selectedOrder.fecha_inicio_blender) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha fin blender:</span>
                <span class="value">{{(selectedOrder.original_fecha_fin_blender || selectedOrder.fecha_fin_blender) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Tiempo de calidad:</span>
                <span class="value">{{selectedOrder.quality_time}}h</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha inicio calidad:</span>
                <span class="value">{{selectedOrder.fecha_inicio_calidad | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha fin calidad:</span>
                <span class="value">{{selectedOrder.fecha_fin_calidad | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
            </div>
            <div class="column is-6">
              <h1 class="title is-4 mb-5">Ordenes de envasado</h1>            

              @for(order of selectedOrder.envasadora_orders; track order)  {
              <div class="field">
                <span class="value-title">Material: </span>
                <span  class="value">{{order.fert}} - {{order.name}}</span>
              </div>
                <div class="field">
                  <span class="value-title">Envasadora:</span>
                  <span class="value px-1">{{order.packaging_machine.id}}</span>
                </div>
                <div class="field">
                  <span class="value-title">Fecha inicio envasasora:</span>
                  <span class="value px-1">{{(order.original_fecha_inicio_envasadora || order.fecha_inicio_envasadora) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
                </div>
                <div class="field">
                  <span class="value-title">Fecha fin envasadora:</span>
                  <span class="value px-1">{{(order.original_fecha_fin_envasadora || order.fecha_fin_envasadora) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
                </div>
                <div class="field">
                  <span class="value-title">Tiempo de envasado:</span>
                  <span class="value px-1">{{order.packaging_time}}h</span>
                </div>
                <div class="field">
                  <span class="value-title">OEE envasadora:</span>
                  <span  class="value px-1">{{order.oee_envasadora}}</span>
                </div>
                <hr>
                
              }
            </div>
            @if(selectedOrder.scores) {
              <div class="column is-6">
                <h1 class="title is-4 mb-5">Scores</h1>            

                <div class="field score">
                  <span class="value-title">Demanda:</span>
                  <span  class="value px-1">{{selectedOrder.score.demanda}}</span>
                </div>
  
                <div class="field score">
                  <span class="value-title">Last day:</span>
                  <span  class="value px-1">{{selectedOrder.score.last_day}}</span>
                </div>
                <div class="field score">
                  <span class="value-title">limpieza:</span>
                  <span  class="value px-1">{{selectedOrder.score.neteja}}</span>
                </div>
                <div class="field score">
                  <span class="value-title">Total score:</span>
                  <span  class="value px-1">{{selectedOrder.score.total_score}}</span>
                </div>
              </div>
            }
          </div>
        } @else if (selectedOrder.type === 'limpieza') {
          <div class="columns is-multiline">
            <div class="column is-6">            
              <div class="field">
                <span class="value-title">Nombre: </span>
                <span>{{selectedOrder.name}}</span>
              </div>
              <div class="field">
                <span class="value-title">Blender:</span>
                <span>{{selectedOrder.blender.id}}</span>
              </div>
              <div class="field">
                <span class="value-title">Duración: </span>
                <span>{{selectedOrder.duration}}</span>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <span class="value-title">Fecha inicio blender:</span>
                <span class="value">{{(selectedOrder.original_fecha_inicio_blender || selectedOrder.fecha_inicio_blender) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
              <div class="field">
                <span class="value-title">Fecha fin blender:</span>
                <span  class="value">{{(selectedOrder.original_fecha_fin_blender || selectedOrder.fecha_fin_blender) | date: 'dd/MM/yyyy HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
        }
      </section>
      
  </div>
}
</div>
  
